import { render } from "./_token.vue?vue&type=template&id=70b76285"
import script from "./_token.vue?vue&type=script&lang=js"
export * from "./_token.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__